// Copyright (c) 2018 Deere & Company

import ExcelLayoutColumn from './excel-layout-column';
import ExcelLayoutSortBy from './excel-layout-sort-by';
import t from 'tcomb';

const ExcelLayout = t.struct({
    columns: t.list(ExcelLayoutColumn, 'ExcelLayoutColumn'),
    isDefault: t.Boolean,
    listId: t.String,
    name: t.String,
    sortBy: t.list(ExcelLayoutSortBy, 'ExcelLayoutSortBy')
}, {
    name: 'ExcelLayout',
    strict: true
});

export const getDefaultState = () => new ExcelLayout({
    columns: [],
    isDefault: false,
    listId: '',
    name: '',
    sortBy: []
});

export default ExcelLayout;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/excel-layout.js